export default "__VITE_ASSET__SQoTyIB6__"